export const TABLE_CONSTANTS = {
  AG_GRID_CONFIG: {
    defaultColDef: {
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      filterParams: { debounceMs: 800 },
    },
    pagination: true,
    paginationPageSize: 30,
    rowBuffer: 10,
    columnDefs: [],
    paginationPageSizeSelector: [10, 20, 30, 50, 100],
    undoRedoCellEditingLimit: 10,
    undoRedoCellEditing: true,
    stopEditingWhenCellsLoseFocus: true,
  },
  RECIPE_TABLE_FIELDS: [
    { field: 'projectName' },
    { field: 'recipeName' },
    { field: 'regionName' },
    { field: 'countryName' },
    { field: 'author' },
    { field: 'categoryName' },
    { field: 'createdOn' },
    { field: 'publishedOn' },
  ],
  INGREDIENT_FAMILY_MAPPING_TABLE: [
    { field: 'ingredientIdentifier', width: 80 },
    { field: 'ingredientName', width: 250 },
    { field: 'ingredientType', width: 150 },
    { field: 'familyName', width: 180 },
    { field: 'isEnabled', width: 200 },
    { field: 'action', width: 120 },
  ],
  INGREDIENT_ASP_TABLE: [
    { field: 'ingredientIdentifier', width: 95 },
    { field: 'ingredientName', width: 150 },
    { field: 'familyName', width: 150 },
    { field: 'ingredientType', width: 150 },
    { field: 'aspViewData', width: 90 },
  ],
  ASP_HISTORY_TABLE: [
    { field: 'regionName', minWidth: 150 },
    { field: 'ingredientASP', width: 200 },
    { field: 'aspApplicableFrom', width: 265 },
    { field: 'aspApplicableTo', width: 265 },
    { field: 'modifiedBy', width: 150 },
  ],
  LOOKUP_TABLE_FIELDS: [
    {
      Family: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'name', colHeader: 'familyName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      UOM: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'name', colHeader: 'uomName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      Currency: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'currencyCode', colHeader: 'code' },
        { field: 'name', colHeader: 'currencyName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      Category: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'name', colHeader: 'categoryName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      Region: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'name', colHeader: 'regionName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      Country: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'regionName', colHeader: 'regionName' },
        { field: 'name', colHeader: 'countryName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
      IngredientType: [
        { field: 'identifier', colHeader: 'identifier' },
        { field: 'name', colHeader: 'ingredientTypeName' },
        { field: 'isEnabled', colHeader: 'isEnabled' },
      ],
    },
  ],
  CURRENCY_EXCHANGE_RATE_MANAGER_TABLE: [
    { field: 'fromCurrencyCode', width: 150 },
    { field: 'toCurrencyCode', width: 150 },
    { field: 'conversionRate', width: 150 },
    { field: 'applicableFrom', width: 150 },
    { field: 'applicableTo', width: 150 },
    { field: 'action', width: 90 },
  ],
  CURRENCY_EXCHANGE_HISTORY_TABLE: [
    { field: 'conversionRate', width: 200 },
    { field: 'applicableFrom', width: 265 },
    { field: 'applicableTo', width: 265 },
  ],
  DEFAULT_CURRENCY_TABLE: [
    { field: 'region' },
    { field: 'country' },
    { field: 'currencyCode' },
    { field: 'uom' },
    { field: 'action' },
  ],
  NUTRITIONAL_INFORMATION_TABLE: [
    { field: 'ingredientIdentifier', width: 150 },
    { field: 'ingredientName', width: 350 },
    { field: 'ingredientType', width: 300 },
    { field: 'familyName', width: 300 },
    { field: 'nutritionalData', minWidth: 150 },
  ],
  INGREDIENT_NUTRITIONAL_INFO_TABLE: [
    { field: 'regionName', minWidth: 150 },
    { field: 'countryName', minWidth: 150 },
    { field: 'calories', minWidth: 140, editable: true },
    { field: 'fat', minWidth: 110, editable: true },
    { field: 'totalSugars', minWidth: 145, editable: true },
    { field: 'addedSugars', minWidth: 145, editable: true },
    { field: 'dietaryFibers', minWidth: 145, editable: true },
    { field: 'protein', minWidth: 145, editable: true },
    { field: 'totalCarbohydrates', minWidth: 190, editable: true },
    { field: 'isEnabled', minWidth: 150, editable: true },
    { field: 'action', minWidth: 110 },
  ],
  INGREDIENT_NUTRITIONAL_INFO_HISTORY_TABLE: [
    { field: 'regionName', minWidth: 150 },
    { field: 'countryName', minWidth: 150 },
    { field: 'fieldName', minWidth: 150 },
    { field: 'oldValue', minWidth: 150 },
    { field: 'newValue', minWidth: 150 },
    { field: 'modifiedOn', minWidth: 210 },
    { field: 'modifiedBy', minWidth: 150 },
  ],
  ROLES_PRIVILEGES_TABLE: [
    { field: 'privilegeGroup', width: 120 },
    { field: 'privilegeName', width: 265 },
    { field: 'isAdminAllowed', width: 115 },
    { field: 'isCategoryOwnerAllowed', width: 170 },
    { field: 'isFormulatorAllowed', width: 140 },
    { field: 'isNonFormulatorAllowed', width: 170 },
  ],
  INGREDIENT_ASP_CURRENT_PRICE_TABLE: [
    { field: 'regionName', width: 95 },
    { field: 'ingredientASP', width: 150 },
    { field: 'aspApplicableFrom', width: 150 },
    { field: 'aspApplicableTo', width: 150 },
    { field: 'modifiedBy', width: 90 },
    { field: 'action', width: 90 },
  ],
  INGREDIENT_REPORT: [
    { field: 'ingredientIdentifier' },
    { field: 'ingredientName' },
    { field: 'recipeCount' },
  ],
  CONFIGURE_PRICING_ADMINS: [
    { field: 'priceApproverName' },
    { field: 'priceApproverEmail' },
    { field: 'action' },
  ],
};
